module.exports = __webpack_public_path__ + "img/brand-7.d8728c53.png";